var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.7,
    height: 21,
    viewBox: "0 0 14.7 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on-2",
    "data-name": "Icon material-location-on",
    d: "M14.85,3A7.345,7.345,0,0,0,7.5,10.35C7.5,15.862,14.85,24,14.85,24s7.35-8.138,7.35-13.65A7.345,7.345,0,0,0,14.85,3Zm0,9.975a2.625,2.625,0,1,1,2.625-2.625A2.626,2.626,0,0,1,14.85,12.975Z",
    transform: "translate(-7.5 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6b0ed5dad70792a9f9c02a09e2a9a203.svg";
export { ForwardRef as ReactComponent };